/**
 * Node height in pixels - used for calculations and vertical spacing between nodes
 */
export const NODE_HEIGHT_PX = 80;
